import React from "react";
import { Text } from "@fluentui/react-northstar";
import taskIcon from "../../../images/print/lifecycle/tasks.png";
import approvalIcon from "../../../images/print/lifecycle/approvals.png";
import { LIFECYCLE, LIFECYCLE_STATUS_GUID } from "../../shared/utils/constants";
import { ApprovalPrint } from "./ApprovalPrint";
import { TaskPrint } from "./TaskPrint";
import { appState } from "../../AppState";

type LifecyclePrintProps = {
  phases: TicketLifecyclePhase[];
  lifecycle: any;
};

const LifecyclePrintPhase: React.FC<{
  phase: TicketLifecyclePhase;
  activePhaseIndex: number;
  lifecycleStatus: LifecycleStatus;
  phasesCount: number;
}> = ({ phase, activePhaseIndex, lifecycleStatus, phasesCount }) => {
  let bgColor = phase.IsCurrent ? "bg-green-100" : "bg-gray-100";

  if (lifecycleStatus.Guid == LIFECYCLE_STATUS_GUID.COMPLETED) {
    bgColor = "bg-completed";
  } else if (lifecycleStatus.Guid == LIFECYCLE_STATUS_GUID.FAILED) {
    bgColor = "bg-red-100";
  }
  const isCompleted = () => {
    if (phasesCount === 1) {
      return phase.LastCompletionDate;
    } else {
      return (
        activePhaseIndex > phase.Order &&
        phase.LastCompletionDate &&
        !phase.IsCurrent
      );
    }
  };

  return (
    <div
      className={`flex items-center justify-between mb-2 ${bgColor} px-3 py-2 mb-3 print-text-color`}
    >
      <div className="flex items-center">
        <Text weight="semibold" className="mr-2">
          {phase.Name}
        </Text>
        {isCompleted() && (
          <Text
            weight="semibold"
            size="smaller"
            className={"text-completed"}
            content={
              <div style={{ marginTop: "3px" }}>
                {" "}
                &bull; <em>{LIFECYCLE.COMPLETED}</em>
              </div>
            }
          />
        )}
      </div>
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <img src={taskIcon} alt="task icon" width="16px" />
          <span>
            {phase.Tasks?.length}{" "}
            {phase.Tasks?.length > 1 ? LIFECYCLE.TASKS : LIFECYCLE.TASK}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <img src={approvalIcon} alt="approval icon" width="16px" />
          <span>
            {phase.Approvals?.length}{" "}
            {phase.Approvals?.length > 1
              ? LIFECYCLE.APPORVALS
              : LIFECYCLE.APPROVAL}
          </span>{" "}
        </div>
      </div>
    </div>
  );
};

export const LifecyclePrint: React.FC<LifecyclePrintProps> = ({
  phases,
  lifecycle,
}) => {
  const currentState = appState();
  const currentUserEmail = currentState.currentUserEmail;
  const activePhaseIndex = phases.find((x) => x.IsCurrent)?.Order ?? 0; // This should be passed as a prop or derived from context
  return (
    <div className="hidden print-block lifecycle-print-container">
      <Text weight="semibold" className="mb-2 print-text-color">
        {LIFECYCLE.NAME}
      </Text>
      <div className="lifecycle-print-content mt-4">
        {phases.map((phase: TicketLifecyclePhase) => (
          <div key={phase.Id} className="lifecycle-phase-container mb-3">
            <LifecyclePrintPhase
              phase={phase}
              activePhaseIndex={activePhaseIndex}
              lifecycleStatus={lifecycle.Status}
              phasesCount={phases.length}
            />
            <TaskPrint tasks={phase.Tasks} />
            <ApprovalPrint
              ticketApprovals={phase.Approvals as TicketApproval[]}
              currentUserEmail={currentUserEmail}
            />
            <TaskPrint tasks={phase.PowerAutomateTasks} powerAutomate/>
          </div>
        ))}
      </div>
    </div>
  );
};
